import React from 'react';
import PdaLogo from 'assets/svg/pdaLight.svg';

import { AiOutlineWarning } from 'react-icons/ai';

import { Container, ModalMessage } from './styles';
import { useComunicatiosHooks } from './hooks/modal.hooks';

const Notification: React.FC = () => {
  const {
    isOpenModal,
    comunicationData,
    currentIndex,
    handlePrev,
    handleNext,
    handleClosesModal,
    handleiGreeNotification,
    handleDontGreeNotification,
  } = useComunicatiosHooks();

  if (!isOpenModal || !comunicationData.length) return null;

  const comunicate = comunicationData[currentIndex];

  return (
    <Container>
      <ModalMessage severidade={comunicate.severidade}>
        <button type="button" className="close" onClick={handleClosesModal}>
          ×
        </button>

        <button
          type="button"
          className="arrow left"
          onClick={handlePrev}
          disabled={currentIndex === 0}
        >
          ‹
        </button>

        <button
          type="button"
          className="arrow right"
          onClick={handleNext}
          disabled={currentIndex === comunicationData.length - 1}
        >
          ›
        </button>

        <div className="contentWrapper">
          <div className="content">
            <div className="top">
              <div className="titleRow">
                <AiOutlineWarning className="icon" />
                <span className="titleBox">{comunicate.titulo}</span>
              </div>
            </div>

            <div className="body">
              <p>{comunicate.corpo}</p>
            </div>
          </div>
        </div>

        {!comunicate.recorrente && (
          <div className="actions">
            <label className="checkbox">
              <input
                name={`${comunicate.codigo}-iDontGree`}
                type="checkbox"
                checked={!comunicate?.disableCheckBox}
                onChange={() => handleDontGreeNotification(comunicate.codigo)}
              />
              <span>Lembrar depois</span>
            </label>

            <label className="checkbox">
              <input
                name={`${comunicate.codigo}-iGree`}
                type="checkbox"
                checked={comunicate?.disableCheckBox}
                onChange={() => handleiGreeNotification(comunicate.codigo)}
              />
              <span>Não Exibir Novamente</span>
            </label>
          </div>
        )}

        <div className="footerRed">{comunicate.rodape}</div>

        <div className="footerBlack">
          <img src={PdaLogo} alt="PDA" />
        </div>
      </ModalMessage>
    </Container>
  );
};

export default Notification;
